var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYellowWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FFE0A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.435 21.7898L18.73 42.9998C18.468 43.4535 18.3294 43.9678 18.328 44.4916C18.3265 45.0154 18.4622 45.5305 18.7216 45.9856C18.981 46.4407 19.3551 46.8199 19.8065 47.0856C20.258 47.3513 20.7712 47.4941 21.295 47.4998H46.705C47.2288 47.4941 47.7419 47.3513 48.1934 47.0856C48.6449 46.8199 49.0189 46.4407 49.2783 45.9856C49.5377 45.5305 49.6735 45.0154 49.672 44.4916C49.6705 43.9678 49.5319 43.4535 49.27 42.9998L36.565 21.7898C36.2976 21.349 35.9211 20.9845 35.4718 20.7315C35.0225 20.4786 34.5156 20.3457 34 20.3457C33.4844 20.3457 32.9775 20.4786 32.5282 20.7315C32.0789 20.9845 31.7024 21.349 31.435 21.7898V21.7898Z",
    stroke: "#705010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 29.5V35.5",
    stroke: "#705010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41.5H34.015",
    stroke: "#705010",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYellowWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/yellowWarning.58b437e5.svg";
export { ForwardRef as ReactComponent };